// extracted by mini-css-extract-plugin
export default {"info-card-label":"info-card-label--fcFq1"};